import { render } from "./PasswordInput.vue?vue&type=template&id=1c19d35c&scoped=true"
import script from "./PasswordInput.vue?vue&type=script&lang=ts"
export * from "./PasswordInput.vue?vue&type=script&lang=ts"

import "./PasswordInput.vue?vue&type=style&index=0&id=1c19d35c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1c19d35c"

export default script